(function () {

  if (!Array.deepClone) {
      Array.deepClone = function(obj) {
          let _result = []
          for (let idx = 0; idx < obj.length; idx++) {
          let _clonedValue = obj[idx]
          if (Array.isArray(_clonedValue)) {
              _clonedValue = Array.deepClone(obj[idx])
          } else if (_clonedValue.constructor === Object) {
              _clonedValue = Object.deepAssign({}, obj[idx])
          }
          _result.push(_clonedValue)
          }
          return _result
      }
  }


  if (!Object.isDist) {
      Object.isDist = function(obj) {
        if(obj) {
          return obj.constructor === Object
        }
        return false
      }
  }


  if (!Object.deepAssign) {

      Object.deepAssign = function () {
          if (arguments.length == 0) {
              return
          }
          if (arguments.length == 1) {
              if (Array.isArray(arguments[0])) {
                  return Array.deepClone(arguments[0])
              }
              return arguments[0]
          }

          let target = arguments[0]
          let source = arguments[1]

          for (let propName in source) {
              if (!source.hasOwnProperty(propName)) { continue }
              let clonedValue = source[propName]
              if (Array.isArray(clonedValue)) {
                  clonedValue = Array.deepClone(source[propName])
              } else if (Object.isDist(clonedValue)) {
                  let _target = target[propName]
                  if (_target && Object.isDist(_target)) {
                      clonedValue = Object.deepAssign(_target, source[propName])
                  }
                  else {
                      clonedValue = Object.deepAssign({}, source[propName])
                  }
              }
              target[propName] = clonedValue
          }

          for (let i=2; i<arguments.length; i++) {
              target = Object.deepAssign(target, arguments[i])
          }

          return target
      }
  }

  }());

// export const deepClone = function (obj) {

//   function deepCloneArray (obj) {
//     let _result = []
//     for (let idx = 0; idx < obj.length; idx++) {
//       let _clonedValue = obj[idx]
//       if (Array.isArray(_clonedValue)) {
//         _clonedValue = deepCloneArray(obj[idx])
//       } else if (typeof _clonedValue === 'object') {
//         _clonedValue = deepClone(obj[idx])
//       }
//       _result.push(_clonedValue)
//     }
//     return _result
//   }

//   let result = {}
//   for (let propName in obj) {
//     if (!obj.hasOwnProperty(propName)) { continue }
//     let clonedValue = obj[propName]
//     if (Array.isArray(clonedValue)) {
//       clonedValue = deepCloneArray(obj[propName])
//     } else if (typeof clonedValue === 'object') {
//       clonedValue = deepClone(obj[propName])
//     }
//     result[propName] = clonedValue
//   }
//   return result
// }

window.css_unit_join = function(value, unit) {
  // vale is int or float or string
  // unit is string or undefined
  // default unit is "px"
  try {
      value = parseFloat(value)
      if (!isNaN(value)) {
          if (!unit) { unit = "px" }
          return value.toString() + unit
      }
  }
  catch(e) {}
  return value
}

export const getLogoPos = function (canvas, img) {
  let pos = {
    x: 0,
    y: 0
  }
  let size = {
    width: 0,
    height: 0
  }
  // size.width = Math.trunc(canvas.width / 12)
  size.width = 34
  size.height = Math.trunc(size.width * (img.height / img.width))
  size.height = Math.trunc(size.width * (img.height / img.width))

  pos.x = Math.trunc(canvas.width - size.width - (size.width * 0.1))
  pos.y = Math.trunc(canvas.height - size.height - (size.height * 0.1))

  return {
    pos: pos,
    size: size
  }
}

export const pointInterpolation = function (track_points, src) {
  let points = track_points
  let op_length = points[points.length - 1].tau - points[0].tau
  let result = []

  let nextPoint = null
  let num = null
  let currPoint = null

  let _do_interp_cnt = null
  let points_tau = points.map(e => e.tau)

  for (let inter_tau of [...Array(op_length + 1).keys()]) {
    let _indexo_points_tau = points_tau.indexOf(inter_tau)

    if (_indexo_points_tau >= 0) {
      currPoint = points[_indexo_points_tau]
      result.push(currPoint)
      nextPoint = points[_indexo_points_tau + 1]
      if (!nextPoint) {
        continue
      }
      num = nextPoint.tau - currPoint.tau
      _do_interp_cnt = 1
    } else {
      let _point = {}
      for (let _property in currPoint) {
        if (['lat', 'lon'].includes(_property)) {
          _point[_property] = currPoint[_property] + ((nextPoint[_property] - currPoint[_property]) / num) * _do_interp_cnt
        }

        else if (['r7', 'r10'].includes(_property)) {

          if (src !== 'BABJ' && src !== 'JMA') {
            // BABJ, JMA 只有定位暴風圈，所以要特別處理
            _point[_property] = currPoint[_property]
          }

        }

        else if (_property !== 'tau') {
          _point[_property] = currPoint[_property]
        } else {
          _point['tau'] = inter_tau
        }
      }
      result.push(_point)
      _do_interp_cnt++
    }
  }
  return result
}

const url_parser = require('url')
export const reverseURL = function (host, url) {
  if (host.indexOf("http") == 0) {
    if (url.charAt(0) === '/') {
      let uri_parsed = url_parser.parse(host, true)
      let res = uri_parsed.host ? uri_parsed.protocol + '//' + uri_parsed.host : ''
      return res + url;
    }
    if (host.charAt(host.length-1) === '/') {
      return host + url;
    }
    return host + '/' + url;
  }

  if (url.charAt(0) === '/') {
    return url;
  }
  if (host.charAt(host.length-1) === '/') {
    return host + url;
  }
  return host + '/' + url;
}

const path = require('path')
export const homeResolve = function (...args) {
  return path.join(__dirname, '..', '..', ...args)
}



// WEBPACK FOOTER //
// ./src/util/index.js